export default __webpack_public_path__ + "static/media/location_preview_gift_shop.92d01021.svg";